import React from "react";
import { useOutletContext } from "react-router-dom";
import { PageContainer } from "../../../components/container/PageContainer";
import { RecordSequencesPanel } from "./RecordSequencesPanel";

/**
 * Shared "Sequences" tab for every policy type (PRD §5.5).
 *
 * All policy layouts pass [customerId, customerPolicyId] through the Outlet
 * context, and for POLICY records the sequence module_code is the
 * customer_policy_id. So a single component serves Automobile, Comm Auto,
 * Business, Habitational and Life policies.
 */
export const PolicySequencesTab: React.FC = () => {
  const ctx = useOutletContext() as any;
  const customerPolicyId = Array.isArray(ctx) ? ctx[1] : undefined;

  return (
    <PageContainer title="Sequences" description="Policy email sequences">
      {customerPolicyId ? (
        <RecordSequencesPanel module="POLICY" moduleCode={customerPolicyId} />
      ) : null}
    </PageContainer>
  );
};
